module.exports = __webpack_public_path__ + "img/pptx.5e5e11d0.svg";